import React, { useEffect, useState } from "react";
import { authAxios } from "../config/config";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import UpdateFooter from "./Models/UpdateFooter";

const Footer = (props) => {

    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const [footerData, setFooterData] = useState(null);

    const [allmodel, setallmodel] = useState({
        data: [],
        showdeletemodel: false,
        showCountrymodel: false,
    });

    const fetchAllData = async () => {

        try {
            const response = await authAxios().get(`/admin/footer`);

            setFooterData(response?.data?.data || null);
        } catch (error) {

            toast.error(error?.response?.data?.message || "Failed to fetch footer data.");
        }
    };
    const handleCancel = () => {
        setallmodel((prev) => ({
            ...prev,
            data: [],
            showdeletemodel: false,
            showCountrymodel: false,
        }))
    }

    const handleUpdate = async (data) => {
        console.log("asdasd", allmodel)
        const payload = data
        await authAxios()
            .put(`/admin/footer`, payload)
            .then((response) => {

                fetchAllData()
                handleCancel()
            }).catch((error) => {

                toast.error(error?.response?.data?.message);
            })
    }

    useEffect(() => {
        fetchAllData();
    }, []);


    if (!footerData) {
        return <div>Loading...</div>;
    }
    const { contactInfo, socialLinks, workingDays, workingHours } = footerData;

    return (
        <footer className="bg-white text-black py-10 border-t border-gray-200">
            <div className="container mx-auto px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Contact Section */}
                    <div>
                        <h3 className="text-lg font-bold mb-4">Contact Us</h3>
                        <ul className="text-sm space-y-2">
                            <li><strong>Phone:</strong> {contactInfo?.phone}</li>
                            <li><strong>Email:</strong> {contactInfo?.email}</li>
                            <li><strong>Address:</strong> {contactInfo?.address?.[currentLanguage]}</li>
                            <li>{contactInfo?.description?.[currentLanguage]}</li>
                        </ul>
                    </div>

                    {/* Social Links */}
                    <div>
                        <h3 className="text-lg font-bold mb-4">Follow Us</h3>
                        <ul className="text-sm space-y-2">
                            {socialLinks?.facebook && (
                                <li>
                                    <a
                                        href={socialLinks.facebook}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:underline text-blue-600"
                                    >
                                        Facebook
                                    </a>
                                </li>
                            )}
                            {socialLinks?.twitter && (
                                <li>
                                    <a
                                        href={socialLinks.twitter}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:underline text-blue-600"
                                    >
                                        Twitter
                                    </a>
                                </li>
                            )}
                            {socialLinks?.instagram && (
                                <li>
                                    <a
                                        href={socialLinks.instagram}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:underline text-blue-600"
                                    >
                                        Instagram
                                    </a>
                                </li>
                            )}
                            {socialLinks?.linkedin && (
                                <li>
                                    <a
                                        href={socialLinks.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:underline text-blue-600"
                                    >
                                        LinkedIn
                                    </a>
                                </li>
                            )}
                             {socialLinks?.youtube && (
                                <li>
                                    <a
                                        href={socialLinks.youtube}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:underline text-blue-600"
                                    >
                                        Yotube
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>

                    {/* Working Hours */}
                    <div>
                        <h3 className="text-lg font-bold mb-4">Working Hours</h3>
                        <ul className="text-sm space-y-2">
                            <li><strong>Days:</strong> {workingDays?.[currentLanguage]}</li>
                            <li><strong>Hours:</strong> {workingHours?.[currentLanguage]}</li>
                        </ul>
                    </div>

                    {/* Update Footer Button */}
                    <div className="flex items-start">
                        <button
                            onClick={() =>
                                setallmodel((prev) => ({
                                    ...prev,
                                    data: footerData,
                                    showCountrymodel: true,
                                }))
                            }
                            className="px-4 py-2 bg-black text-white rounded-md shadow hover:bg-white hover:text-black focus:outline-none"

                        >
                            Update Footer
                        </button>
                    </div>
                </div>
            </div>

            {
                allmodel.showCountrymodel && <UpdateFooter handleCancel={handleCancel} allmodel={allmodel} handleUpdate={handleUpdate} />
            }


        </footer>
    );
};

export default Footer;
